module.exports = __webpack_public_path__ + "static/media/3.45e479ce.svg";